import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KorisniciComponent } from './korisnici.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { KorisniciService } from './services/korisnici.service';
import { KorisniciValidationService } from './services/korisnici-validation.service';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [KorisniciComponent],
  entryComponents: [KorisniciComponent],
  exports: [KorisniciComponent],
  providers: [KorisniciService, KorisniciValidationService],
})
export class KorisniciModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/korisnici/korisnici.module.ts